import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-012bd912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-bank-modal" }
const _hoisted_2 = { class: "assign-trustcontact" }
const _hoisted_3 = { class: "heading-text" }
const _hoisted_4 = { class: "line1" }
const _hoisted_5 = { class: "body-main" }
const _hoisted_6 = { class: "ls-form" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Bank name:", -1))
const _hoisted_8 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "BSB:", -1))
const _hoisted_11 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Account number:", -1))
const _hoisted_14 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_16 = { class: "controls mt-4" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ModalBox, {
        halfScreen: "true",
        onClose: _cache[5] || (_cache[5] = $event => (_ctx.closeModal()))
      }, {
        "header-text": _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.isEditMode ? 'Edit bank': 'Add new bank'), 1)
          ])
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(["input-box", _ctx.bankName == '' && _ctx.formDirty ? 'error' : ''])
                }, [
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.bankName) = $event)),
                    placeholder: "Enter name of the Bank",
                    maxlength: "50",
                    minLength: "50"
                  }, null, 512), [
                    [_vModelText, _ctx.bankName]
                  ]),
                  (_ctx.bankName == '' && _ctx.formDirty)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createTextVNode(" Must not be empty ")
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["input-box", _ctx.bsbno == '' && _ctx.formDirty ? 'error' : ''])
                }, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.bsbno) = $event)),
                    placeholder: "Enter BSB number",
                    maxlength: "6",
                    minLength: "6",
                    onkeydown: "if(!(event.key === 'Delete' || event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'Backspace' || event.key === 'Tab' || /\\d/.test(event.key))){event.preventDefault();}"
                  }, null, 512), [
                    [_vModelText, _ctx.bsbno]
                  ]),
                  (_ctx.bsbno == '' && _ctx.formDirty)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _hoisted_12,
                        _createTextVNode(" Must not be empty ")
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["input-box", _ctx.accountNo == '' && _ctx.formDirty ? 'error' : ''])
                }, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.accountNo) = $event)),
                    placeholder: "Account number",
                    maxlength: "20",
                    minLength: "20"
                  }, null, 512), [
                    [_vModelText, _ctx.accountNo]
                  ]),
                  (_ctx.accountNo == '' && _ctx.formDirty)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createTextVNode(" Must not be empty ")
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            (_ctx.submitting)
              ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                  key: 0,
                  class: "loading-indicator",
                  showLoadingText: false
                }))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-outline",
              disabled: _ctx.submitting,
              onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
            }, " Cancel ", 8, _hoisted_17),
            _createElementVNode("button", {
              class: "btn btn-primary",
              disabled: _ctx.submitting,
              onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.save()), ["prevent","stop"]))
            }, [
              (_ctx.isEditMode)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Save"))
                : (_openBlock(), _createElementBlock("span", _hoisted_20, "Add"))
            ], 8, _hoisted_18)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}